// 用意するオプションの総数
const options = {
  deletable: true,
  type: null,
  caption: null,
  required: false,
  requiredFixed: false,
  defaultLine: 5,
  titleType: null,
  options: null,
  optionsFirstEmpty: false,
  placeholder: null,
  description: null,
  width: 300,
  direction: 'horizontal',
  daySelectType: 'single',
  fileTypes: null,
  id: null,
  class: null,
  name: null
}

const components = {
  address: {
    type: 'address',
    caption: '住所'
  },
  date: {
    type: 'date',
    caption: '日付'
  },
  text: {
    type: 'text',
    caption: '1行テキスト'
  },
  textarea: {
    type: 'textarea',
    caption: '複数行テキスト'
  },
  checkbox: {
    type: 'checkbox',
    caption: '複数選択'
  },
  radio: {
    type: 'radio',
    caption: '単一選択'
  },
  dropdown: {
    type: 'dropdown',
    caption: 'ドロップダウンリスト'
  },
  file: {
    type: 'file',
    caption: '添付ファイル'
  }
}

// 初期作成時の
const defaults = [
  {
    deletable: false,
    type: 'title',
    caption: '件名',
    required: true,
    requiredFixed: true,
    titleType: 'free'
  },
  {
    deletable: false,
    type: 'name',
    caption: '氏名',
    required: true,
    requiredFixed: true
  },
  {
    deletable: false,
    type: 'mail',
    caption: 'メールアドレス',
    required: true,
    requiredFixed: true
  }
  // {
  //   deletable: false,
  //   type: 'textarea',
  //   caption: 'お問合せ内容',
  //   required: true,
  //   requiredFixed: true,
  //   defaultLine: 5
  // }
]

let defaultParts = []
for (let part of defaults) {
  defaultParts.push(Object.assign({}, options, part))
}

let uniqId = () => {
  return new Date().getTime().toString(16) + Math.floor(Math.random() * 1000000).toString(16)
}

let getItem = (name) => {
  return Object.assign({}, options, components[name], { id: uniqId() })
}

export {
  defaultParts, uniqId, getItem, components
}



// WEBPACK FOOTER //
// ./src/components/dashboard/form/part/PartConfig.js